import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex);

const state={   //要设置的全局访问的state对象
  IsShowNickname:false,
  Nickname:'',
  PageSize:10,
  LastTime:new Date().getTime(),    //最后一次修改时间
  TimeOut:30 * 60 * 1000,           //设置超时时间： 30分钟
  Domain:'https://api.chinaesaga.org.cn/api/djrz/',
  //Domain:'http://192.168.1.147:8888/api/djrz/',
  loadingPara:{lock: true ,text: '请稍等', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' }
};

const getters = {   //实时监听state值的变化(最新状态)
  isShow(state) {  
     return state.IsShowNickname
  },
  nickName(state) {  
    return state.Nickname
 },
 pageSize(state) {  
  return state.PageSize
 },
 domain(state) {  
  return state.Domain
 },
 lastTime(state) {  
  return state.LastTime
 },
 timeOut(state) {  
  return state.TimeOut
 },
 loadingPara(state){
   return state.loadingPara
 }
};

const mutations = {
  show(state,val) {   //自定义改变state初始值的方法，这里面的参数除了state之外还可以再传额外的参数(变量或对象);
      state.IsShowNickname = true;
      state.Nickname=val;
  },
  hide(state) {  //同上
      state.IsShowNickname = false;
  },
  updateLastTime(state,val){
    state.LastTime=val;
  }
};

const actions = {
  hideActions(context) {  //自定义触发mutations里函数的方法，context与store 实例具有相同方法和属性
      context.commit('hide');
  },
  showActions(context,val) {  //同上注释
      context.commit('show',val);
  },
  updateLastTimeActions(context,val) {  //同上注释
    context.commit('updateLastTime',val);
  }
};

//创建Vuex实例
const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions
})
export default store;





// WEBPACK FOOTER //
// ./src/store/index.js